import { render, staticRenderFns } from "./organdevice.vue?vue&type=template&id=1a628f74"
import script from "./organdevice.vue?vue&type=script&lang=js"
export * from "./organdevice.vue?vue&type=script&lang=js"
import style0 from "./organdevice.vue?vue&type=style&index=0&id=1a628f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports